import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    image: {
      cursor: 'pointer',
      width: '100%',
    },
    text: {
      cursor: 'pointer',
      color: '#CFCFCF',
    },
  }),
);

export default useStyles;
